
import { useContext, useEffect } from 'react'
import { m } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// auth
import { useAuthContext } from 'src/auth/hooks';
// context
import { FormShareContext, ConfigContext } from 'src/context/Context';
// components
import { varHover } from 'src/components/animate';
import { useSnackbar } from 'src/components/snackbar';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
//
import { HOST_API } from 'src/config-global';


// ----------------------------------------------------------------------

const OPTIONS = [
  {
    label: 'Home',
    linkTo: '/',
  },
  {
    label: 'Profile',
    linkTo: paths.organizationNewPath,
  },
  {
    label: 'Settings',
    linkTo: paths.dashboard.user.account,
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {

  const router = useRouter();
  const navigate = useNavigate();

  const { user, logout, initialize } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const profile = useContext(ConfigContext);
  const reload  = useContext(FormShareContext);

  const popover = usePopover();

  let name = `${user?.name}`;

  if(user?.firstName) name = `${name} ${user?.firstName}`

  const avatar = user?.avatar === '' ? null : `${HOST_API}${user?.avatar}`;

  const handleLogout = async () => {
    try {
      await logout();
      popover.onClose();
      router.replace('/auth/jwt/login');
    } catch (error) {
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    } 

  };

  const handleClickItem = (path) => {
    popover.onClose();

    if(user?.role === "organization"){
      router.push(paths.organizationNewPath);
    }else if(user?.role === "administrator"){
      navigate('/users/edition', {state:{userID : user?.id, profil: true}})
      reload.updateReloadModalShare(true);
    }else if(user?.role === "manager"){
      navigate('/manager/profile')
    }else if(user?.role === "trainee"){
     navigate('/organization/trainees/profile', { state: { traineeID: user?.id, role:"trainee" } });
    }
    
  };

  useEffect(()=>{
    initialize();
  },[profile.profileSave]);

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={avatar}
          alt={user?.displayName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {name.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>

          <MenuItem onClick={() => handleClickItem()}>Profil</MenuItem>

        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={ () => handleLogout()  }
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Se déconnecter
        </MenuItem>
      </CustomPopover>
    </>
  );
}



const mapStateToProps = (state) => ({ settings: state.settings });

const mapDispatchToProps = (dispatch) => ({});

export const AccountPopoverStore = connect(mapStateToProps, mapDispatchToProps)(AccountPopover);
